var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button", id: "consultar" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", {
                  staticClass: "fa fa-search",
                  attrs: { "aria-hidden": "true" }
                }),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-group select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field select2-field--stretch" },
                  [
                    _c("v-select", {
                      attrs: {
                        multiple: "",
                        id: "rutas",
                        placeholder: "Todas...",
                        options: _vm.rutas,
                        label: "descripcion"
                      },
                      on: { search: _vm.onSearchRutas },
                      model: {
                        value: _vm.rutasSeleccionadas,
                        callback: function($$v) {
                          _vm.rutasSeleccionadas = $$v
                        },
                        expression: "rutasSeleccionadas"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "rutas" } }, [_vm._v("Rutas")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline form-inline--stretch" }, [
                _c("div", { staticClass: "form-inline__title" }, [
                  _vm._v("\n              Estado\n            ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-inline__content" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado_ruta,
                          expression: "form.estado_ruta"
                        }
                      ],
                      attrs: { type: "radio", value: "A" },
                      domProps: { checked: _vm._q(_vm.form.estado_ruta, "A") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado_ruta", "A")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Activos")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado_ruta,
                          expression: "form.estado_ruta"
                        }
                      ],
                      attrs: { type: "radio", value: "I" },
                      domProps: { checked: _vm._q(_vm.form.estado_ruta, "I") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado_ruta", "I")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Inactivos")])
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado_ruta,
                          expression: "form.estado_ruta"
                        }
                      ],
                      attrs: { type: "radio", value: "T" },
                      domProps: { checked: _vm._q(_vm.form.estado_ruta, "T") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.form, "estado_ruta", "T")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Todos")])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("vue-good-table", {
                  attrs: {
                    columns: _vm.columns,
                    mode: "remote",
                    "pagination-options": {
                      enabled: true,
                      perPage: 20,
                      perPageDropdown: [],
                      nextLabel: "siguiente",
                      prevLabel: "anterior",
                      rowsPerPageLabel: "Registros por página",
                      ofLabel: "de",
                      allLabel: "Todo",
                      dropdownAllowAll: true
                    },
                    rows: _vm.registros,
                    "search-options": {
                      enabled: false
                    },
                    styleClass: "vgt-table vgt-table--sticky"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "table-row",
                      fn: function(props) {
                        return [
                          props.column.field == "saldo.fecha"
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      props.row.saldo
                                        ? props.row.saldo.fecha.split(" ")[0]
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            : props.column.field == "saldo.saldo"
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      props.row.saldo
                                        ? _vm.moneyFormat(props.row.saldo.saldo)
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            : props.column.field == "acciones" &&
                              props.row.saldo
                            ? _c("span", [
                                _vm.puedeEditar
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn-success btn--text",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editar(props.row)
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "base",
            width: "50%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("saldo-base", {
            on: { saved: _vm.saved, cancelar: _vm.cancelar },
            model: {
              value: _vm.rutaSeleccionada,
              callback: function($$v) {
                _vm.rutaSeleccionada = $$v
              },
              expression: "rutaSeleccionada"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Bases por Rutas")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-794fabcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-794fabcc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/basesrutas/BaseRuta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-794fabcc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/basesrutas/BaseRuta.vue
// module chunks = 0